import {Theme, useFundamentalContext} from '@hm/fundamental'
import {useEffect} from 'react'

const HCEM_THEME_LIGHT: Theme = 'ThemeLightBlue'

export const FundamentalThemeInitializer = () => {
  const {theme: fundamental} = useFundamentalContext()

  useEffect(() => {
    if (fundamental.currentTheme !== HCEM_THEME_LIGHT) {
      fundamental.updateTheme(HCEM_THEME_LIGHT)
    }
  }, [fundamental])

  return null
}
